import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { SignInUpComponent } from './components/sign-in-up/sign-in-up.component';

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', component: SignInUpComponent, },
  ])
  ],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
